export default "__VITE_ASSET__harNdlq5__"